import alerts from "./alert-actions";
import contacts from "./contact-actions";
import files from "./file-actions";
import groups from "./group-actions";
import track from "./track-actions";
import page from "./page-actions";
import people from "./people-actions";
import reports from "./report-actions";
import user from "./user-actions";
import admin from "./admin-actions";
import messages from "./message-actions";
import escalation from "./escalation-actions";
import embedAlerts from "./embed-alert-actions";
import families from "./family-actions";
import familyWorkgroups from "./family-workgroup-actions";
import memberWorkgroups from "./member-workgroup-actions";
import members from "./member-actions";
import parishSoftApis from "./parish-soft-actions";
import language from "./language-actions";
import account from "./account-actions";
import facebook from "./facebook-actions";
import payment from "./payment-actions";
import manageMessagePlan from "./manage-message-plan-actions";
import inAppNotifications from "./in-app-notification-actions";
import passwordRecovery from "./password-recovery-actions";
import embedNotifications from "./embed-notification-actions";

const actions = {
  alerts: alerts,
  contacts: contacts,
  files: files,
  groups: groups,
  track: track,
  page: page,
  people: people,
  admin: admin,
  reports: reports,
  user: user,
  messages: messages,
  escalation: escalation,
  embedAlerts: embedAlerts,
  families: families,
  familyWorkgroups: familyWorkgroups,
  memberWorkgroups: memberWorkgroups,
  members: members,
  parishSoftApis: parishSoftApis,
  language: language,
  account: account,
  facebook: facebook,
  payment: payment,
  manageMessagePlan: manageMessagePlan,
  inAppNotifications: inAppNotifications,
  passwordRecovery: passwordRecovery,
  embedNotifications: embedNotifications,
};
export default actions;
